import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Polyline, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (color, label) =>
  L.divIcon({
    className: "",
    html: `<div style="background:${color};width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.3);display:flex;align-items:center;justify-content:center;">
      <span style="transform:rotate(45deg);color:#fff;font-weight:800;font-size:12px;">${label}</span></div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
  });

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 1) map.setView(points[0], 13);
    else if (points.length > 1) map.fitBounds(points, { padding: [40, 40] });
  }, [points, map]);
  return null;
}

export function RouteMap({ origin, destination, geometry, live, height = 260 }) {
  const points = [];
  if (origin?.lat != null) points.push([origin.lat, origin.lng]);
  if (destination?.lat != null) points.push([destination.lat, destination.lng]);
  if (live?.lat != null) points.push([live.lat, live.lng]);
  const center = points[0] || [-33.4489, -70.6693];
  const fitPts = live?.lat != null ? points : (geometry?.length ? geometry : points);

  return (
    <div className="rounded-2xl overflow-hidden border border-zinc-200" style={{ height }} data-testid="route-map">
      <MapContainer center={center} zoom={12} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {origin?.lat != null && <Marker position={[origin.lat, origin.lng]} icon={pin("#059669", "A")}><Popup>Origen</Popup></Marker>}
        {destination?.lat != null && <Marker position={[destination.lat, destination.lng]} icon={pin("#FF5A36", "B")}><Popup>Destino</Popup></Marker>}
        {live?.lat != null && <Marker position={[live.lat, live.lng]} icon={pin("#2563EB", "T")}><Popup>Transportista</Popup></Marker>}
        {geometry?.length > 1 && <Polyline positions={geometry} pathOptions={{ color: "#FF5A36", weight: 5, opacity: 0.85 }} />}
        <FitBounds points={fitPts} />
      </MapContainer>
    </div>
  );
}


export function PointMap({ lat, lng, height = 200 }) {
  if (lat == null || lng == null) return null;
  return (
    <div className="rounded-2xl overflow-hidden border border-zinc-200" style={{ height }} data-testid="point-map">
      <MapContainer key={`${lat}-${lng}`} center={[lat, lng]} zoom={16} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={[lat, lng]} icon={pin("#FF5A36", "")} />
      </MapContainer>
    </div>
  );
}
